const monday = 'Monday';
const tuesday = 'Tuesday';
const wednesday = 'Wednesday';
const thursday = 'Thursday';
const friday = 'Friday';
const saturday = 'Saturday';
const sunday = 'Sunday';

export const DaysOfWeek = Object.freeze({
    [sunday]: 0,
    [monday]: 1,
    [tuesday]: 2,
    [wednesday]: 3,
    [thursday]: 4,
    [friday]: 5,
    [saturday]: 6,
});

export const DaysOfWeekKeys = Object.freeze({
    0: sunday,
    1: monday,
    2: tuesday,
    3: wednesday,
    4: thursday,
    5: friday,
    6: saturday,
});
